import { IProgram, ICourse, SearchType } from './ISearchService';

export enum PrintType {
	Results,
	Detail,
	Favorites,
	EmailGrid,
}

export class PrintContext {
	public constructor (public printType: PrintType, public items: IProgram[] | ICourse[],
		public searchType: SearchType, public path: string) {

	}
}
